import * as React from "react";

import { cn } from "@/lib/utils";

/* Motion Guidelines:
   - Focus: border color #719475, shadow 0px 0px 0px 4px rgba(113,148,117,0.2)
   - 180ms ease transition
   - No movement
*/
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-14 w-full rounded-[20px] border border-graphit/20 bg-background px-4 py-3 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-waldgruen focus-visible:shadow-[0px_0px_0px_4px_rgba(113,148,117,0.2)] disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-[180ms] ease-out",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
